// ABOUTME: Accessibility hook for respecting user's reduced motion preference
// ABOUTME: Returns boolean indicating if reduced motion is preferred by the user

import { useReducedMotion as useFramerReducedMotion } from "framer-motion";

export function useReducedMotion(): boolean {
  return useFramerReducedMotion() ?? false;
}
